import { ErrorHandler } from '@angular/core';

//declare var newrelic: any;

export class AppGlobalErrorhandler implements ErrorHandler {
  handleError(error) {
    console.error(error);
   // newrelic.noticeError(error);
  }
}
